import React from 'react';

import { TextInput } from '@components/admin/Forms';
import { bookingInquiryStrings } from '@data/bookingInquiry';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { createStrings } from '@utils/local';

export const strings = createStrings({
  ja: {
    preferredArrivalDateTip: () => (
      <>
        *実際の納品可能日は
        <b>輸入本船入港日</b>
        に基づき、再確認することが必要です
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  inputTip: {
    ...common.textGray700,
    ...common.exSmallerText,
    margin: '0.25rem 0',
    paddingLeft: '7rem',
    '& a': {
      ...common.caution,
      ...common.baseButton,
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  container: {
    padding: '2rem 1rem',
    minHeight: '163px',
    [theme.breakpoints.down('sm')]: {
      minHeight: 0,
      padding: '1rem',
    },
  },
}));

export const PreferredArrivalDateInput: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div className={classes.container}>
      <TextInput
        name="preferred_arrival_date"
        label={bookingInquiryStrings.preferredArrivalDate}
        type="text"
        placeholder={bookingInquiryStrings.preferredArrivalDatePlaceholder}
      />
      <div className={classes.inputTip}>{strings.preferredArrivalDateTip()}</div>
    </div>
  );
};
